import { render, staticRenderFns } from "./InformationGraph.vue?vue&type=template&id=8a36975e&scoped=true"
import script from "./InformationGraph.vue?vue&type=script&lang=js"
export * from "./InformationGraph.vue?vue&type=script&lang=js"
import style0 from "./InformationGraph.vue?vue&type=style&index=0&id=8a36975e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a36975e",
  null
  
)

export default component.exports